import { Translation } from "anketa-core/i18n";
import { setupNetworkGroup } from "./network-scan";
import { Section } from "anketa-core/group";

const NetworkSetupEn = await fetch(require("./tutorial/setup/en.md")).then(
  (res) => res.text()
);
const NetworkSetupDe = await fetch(require("./tutorial/setup/de.md")).then(
  (res) => res.text()
);

// Build a fresh section per catalog. The OpsanioCatalog is rebuilt for every
// questionnaire (see createInstance) and each build re-parents this section;
// a shared module-level singleton would keep its parent (and answers) from the
// previous build and throw "item 'network_scanner' has already a parent".
export const networkScanners = (): Section => {
  const networkScanners = new Section("network_scanner", [
    new Translation("en", "Network Scanners"),
    new Translation("en", "Netzwerk-Scanner"),
  ]);

  networkScanners.help = [
    new Translation(
      "en",
      `Define which networks the appliance is allowed to scan.`
    ),
    new Translation(
      "de",
      `Nachfolgend können Sie festlegen, welche Netzwerke die Appliance scannen darf (Anzeigename wird automatisch übernommen).`
    ),
  ];

  networkScanners.description = [
    new Translation("en", NetworkSetupEn),
    new Translation("de", NetworkSetupDe),
  ];
  setupNetworkGroup(networkScanners, 0);
  return networkScanners;
};
